import React, { useState, useEffect } from 'react';
import { prepareInput } from '../Input';
import { Button } from '~c/ui/Button';

import routes from '~/apiRouter';

export const Promo = (props) => {
  const inputDefault = {
    name: 'promo',
    label: 'Промокод',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: false,
    validator: () => {},
    renderBlock: 1,
  };

  const [promo, setPromo] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [isValidationPassed, setIsValidationPassed] = useState(false);
  const [input, setInput] = useState(inputDefault);
  const [blockedTimeout, setBlockedTimeout] = useState(0);

  useEffect(() => {
    if(blockedTimeout){
      setTimeout(() => {
        setBlockedTimeout(blockedTimeout - 1);
      }, 1000);
    }
  }, [blockedTimeout]);

  const validatePromo = async () => {
    if(blockedTimeout || isValidationPassed || isPending) return;

    const newInput = { ...input };
    if (!promo) {
      newInput.error = false;
      setInput(newInput);
      return;
    }

    setIsPending(true);
    try {
      const url = `${routes.user.verifyPromo}`;
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          EVENT_CODE: props.eventCode,
          PROMO_CODE: promo,
          COMPANY_ID: null,
        }),
      };
      const response = await fetch(url, options);
      const json = await response.json();

      if(json.errors.length !== 0){
        newInput.error = true;
        setBlockedTimeout(30);
      }

      setInput(newInput);
      setIsValidationPassed(json.status === 'success');
    } catch (e) {
      newInput.error = true;
      setInput(newInput);
    } finally {
      setIsPending(false);
    }
  };

  const onChange = (val) => {
    setIsValidationPassed(false);
    setInput(inputDefault);
    setPromo(val);
    props.onChange(val);
  };

  return (
    <div className="promo-container">
      <h4 className="heading heading--2">Применить промокод</h4>
      <div className="promo-form">
        <div className="promo-inputs inp-wrap">
          {prepareInput({
            ...input,
            value: promo,
            onChangeCallback: (name, val) => onChange(val),
          })}
        </div>
        <Button
          disabled={blockedTimeout} 
          onClick={validatePromo} 
          className={`promo-form__btn btn ${isValidationPassed ? 'btn--success' : 'btn--outline'}`}
          extraLoaderClass='red'
          isPending={isPending}
        >
         {isValidationPassed ? 'Верный промокод' : 'Проверить'}
        </Button>
      </div>
      { blockedTimeout ? (
        <div className="error error--adoptive error--red">
          Неверный промокод. Повторно проверить можно через <b>{blockedTimeout} сек.</b>
        </div>
      ) : ''}
    </div>
  );
};

